import { useEffect, useLayoutEffect } from 'react'

/**
 * useLayoutEffect but suppresses warnings on SSR
 */
export const useIsoLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
